import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementModerationReasons(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementModerationReasons?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementModerationReasons", responseData.data);
  },

  async postEngagementModerationReason(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementModerationReason`,
      "POST",
      null,
      payload
    );
  },
  async putEngagementModerationReason(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateEngagementModerationReason`,
      "PUT",
      null,
      payload
    );
  },

  async deleteEngagementModerationReason(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementModerationReason`,
      "POST",
      null,
      postData
    );
  },
};
